import React from "react";
import LoadingSpinner from "./LoadingSpinner";

export default function DataTableLoadingRow({ colSpan, label }) {
  return (
    <tr className="data-table-loading-row">
      <td colSpan={colSpan}>
        <LoadingSpinner className="data-table-loading-state" label={label} />
      </td>
    </tr>
  );
}
